import { createSlice } from "@reduxjs/toolkit";

// initial state
const initialState = {
  projects: [],
  searchQuery: "",
};

// createSlice
const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setProjects(state, action) {
      // if id exist in projects array, remove it
      // else add it
      const index = state.projects.indexOf(action.payload);
      if (index > -1) {
        state.projects.splice(index, 1);
      } else {
        state.projects.push(action.payload);
      }
    },
    setAllProjects(state, action) {
      state.projects = action.payload;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
  },
});

// export actions
export const { setProjects, setAllProjects, setSearchQuery } =
  filterSlice.actions;

// export reducer
export default filterSlice.reducer;
